<template>
  <div class="flex-grow flex flex-col justify-center">
    <HeroSegment />
    <VideoSegment ref="videoSegment" class="z-20 snap-start" />
    <BundleSegment class="z-30 snap-start" />
    <ScreenSegment class="z-40 snap-start" />
    <MoreSegment class="z-50 snap-start" />
    <PaymentTerminalSegment class="z-[60] snap-start" />
  </div>
</template>

<script setup lang="ts">
import HeroSegment from '@/views/home/HeroSegment.vue'
import VideoSegment from '@/views/home/VideoSegment.vue'
import BundleSegment from '@/views/home/BundleSegment.vue'
import ScreenSegment from '@/views/home/ScreenSegment.vue'
import MoreSegment from '@/views/home/MoreSegment.vue'
import PaymentTerminalSegment from '@/views/home/PaymentTerminalSegment.vue'
import { nextTick, onMounted, onUnmounted, ref } from 'vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { useRoute } from 'vue-router'

const breakpoints = useBreakpoints(breakpointsTailwind)
const route = useRoute()
const videoSegment = ref()

onMounted(() => {
  // if (breakpoints.isGreaterOrEqual('md')) {
  //   document.querySelector('.scroll-container')?.classList.add('enable-snap')
  // }
  if (route.name === 'demo') {
    nextTick(() => {
      videoSegment.value.scroll()
    })
  }
})

onUnmounted(() => {
  // document.querySelector('.scroll-container')?.classList.remove('enable-snap')
})
</script>
